import ChevronRightSmallIconPath from "@ingka/ssr-icon/paths/chevron-right-small";

export default ChevronRightSmallIconPath;
